module.exports = __webpack_public_path__ + "8b4e5b875025f430c6b764f22ef0c07c.pdf";